import type { TradeSelectorVariant } from "@simplybusiness/mobius-trade-selector";
import type { QuestionComponentProps } from "../../types";
import { useExperiment } from "../../../../../../../hooks/experiments";
import { TradeQuestion as DefaultTradeQuestion } from "./TradeQuestion";
import { TradeQuestion as TreatmentTradeQuestion } from "./ExperimentTradeSelectorSupportPills/TradeQuestion";
import { AiTradeQuestion } from "./AiTradeQuestion";

export const TradeQuestion = (props: QuestionComponentProps) => {
  const { type } = props;

  const variant: TradeSelectorVariant =
    type === "trade_search_ai" ? "ai" : "default";

  const isPillsTreatment =
    useExperiment("uk2603TradeSelectorSupportPills") === "treatment";

  if (variant === "ai") {
    return <AiTradeQuestion {...props} />;
  }

  if (isPillsTreatment) {
    return <TreatmentTradeQuestion {...props} />;
  }

  return <DefaultTradeQuestion {...props} />;
};
